import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/footer-logo.png';
import _imports_1 from '../assets/image/wechat-qrcode.jpg';
import _imports_2 from '../assets/image/icon-weibo.png';
const _withScopeId = n => (_pushScopeId("data-v-137fd68a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "vlian-footer"
};
const _hoisted_2 = {
  class: "col-layout"
};
const _hoisted_3 = {
  class: "flex v-footer-wrap"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("p", null, "国家广播电视总局2022年度全国广播电视媒体融合成长项目"), /*#__PURE__*/_createElementVNode("p", null, "中国版权协会常务理事单位"), /*#__PURE__*/_createElementVNode("p", null, "湖南省版权协会常务理事单位"), /*#__PURE__*/_createElementVNode("p", null, "长沙市版权协会副会长单位"), /*#__PURE__*/_createElementVNode("p", null, "长沙市电影电视艺术家协会理事单位"), /*#__PURE__*/_createElementVNode("p", null, "2025年省级文化强省发展项目"), /*#__PURE__*/_createElementVNode("p", null, "入选第四批国家广播电视和网络视听产业发展项目库")], -1));
const _hoisted_5 = {
  class: "right-link-box"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "li-bold-text"
}, "关于", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "li-bold-text"
}, "产品", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://blockchain.vlian.cn/",
  target: "_blank"
}, "区块链浏览器")], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "li-bold-text"
}, "服务", -1));
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<ul data-v-137fd68a><li class=\"li-bold-text\" data-v-137fd68a>关注我们</li><li data-v-137fd68a><div class=\"we-qrcode-box\" data-v-137fd68a><img class=\"qrcode-img\" alt=\"\" src=\"" + _imports_1 + "\" data-v-137fd68a><p data-v-137fd68a>微信公众号</p></div></li><li class=\"weibo-link flex\" data-v-137fd68a><a href=\"https://weibo.com/u/7764879975\" target=\"_blank\" class=\"flex\" data-v-137fd68a><img alt=\"\" src=\"" + _imports_2 + "\" data-v-137fd68a><p data-v-137fd68a>微博</p></a></li></ul>", 1);
const _hoisted_11 = {
  class: "flex v-footer-info-wrap"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-align-center"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43010502001506",
  target: "_blank",
  style: {
    "display": "inline-flex"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "//vlian.cn/icon-gongan.png",
  alt: "",
  style: {
    "width": "18px",
    "height": "18px"
  }
}), /*#__PURE__*/_createTextVNode(" 湘公网安备 43010502001506号 ")]), /*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}, "湘ICP备19015264号-4"), /*#__PURE__*/_createElementVNode("span", null, "湘网信备43010522727419490016号"), /*#__PURE__*/_createElementVNode("span", null, "湘网文〔2022〕3306-114 号")], -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("span", null, "增值电信业务经营许可证：湘B2-20220418"), /*#__PURE__*/_createElementVNode("span", null, "广播电视节目制作经营许可证：（湘马视）字第00029号"), /*#__PURE__*/_createElementVNode("span", null, "信息网络传播视听节目许可证号：1184200118")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("ul", null, [_hoisted_6, _createElementVNode("li", {
    class: "link",
    onClick: _cache[0] || (_cache[0] = $event => $options.toHelp(1))
  }, "关于我们"), _createElementVNode("li", {
    class: "link",
    onClick: _cache[1] || (_cache[1] = $event => $options.toHelp(6))
  }, "权责声明"), _createElementVNode("li", {
    class: "link",
    onClick: _cache[2] || (_cache[2] = $event => $options.toHelp(15))
  }, "媒体报道"), _createElementVNode("li", {
    class: "link",
    onClick: _cache[3] || (_cache[3] = $event => $options.toHelp(74))
  }, "通知公告")]), _createElementVNode("ul", null, [_hoisted_7, _createElementVNode("li", null, [_createVNode(_component_router_link, {
    class: "link",
    to: "/creator/upload",
    target: "_blank"
  }, {
    default: _withCtx(() => [_createTextVNode("上传视频")]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    class: "link",
    to: "/ablum/1",
    target: "_blank"
  }, {
    default: _withCtx(() => [_createTextVNode("热门严选")]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    class: "link",
    target: "_blank",
    to: "/ablum/detail/68"
  }, {
    default: _withCtx(() => [_createTextVNode("免费专区")]),
    _: 1
  })]), _hoisted_8]), _createElementVNode("ul", null, [_hoisted_9, _createElementVNode("li", {
    class: "link",
    onClick: _cache[4] || (_cache[4] = $event => $options.toHelp(2))
  }, "帮助中心"), _createElementVNode("li", {
    class: "link",
    onClick: _cache[5] || (_cache[5] = $event => $options.toHelp(12))
  }, "联系我们"), _createElementVNode("li", {
    class: "link",
    onClick: _cache[6] || (_cache[6] = $event => $options.toHelp(17))
  }, "平台活动")]), _hoisted_10])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_createElementVNode("p", null, " ©2022-" + _toDisplayString(new Date().getFullYear()) + " 版权所有 中国V链 湖南马栏山天择微链科技有限公司 ", 1), _hoisted_12, _hoisted_13])])])]);
}